// extracted by mini-css-extract-plugin
export var collapsedSummary = "_r7-0";